import { createSelector, createFeatureSelector } from '@ngrx/store';
import { EventSystemComplete } from '../../models/event-systems/event-system-complete.model';
import { EventSystemStore } from '../models/event-system.models';
import { systemAdapter } from '../adapters/event-system.adapter';
import { AppState } from '../app.state';
import { selectAppState } from './app.selector';

const selectEventSystemStore = createSelector(
    selectAppState,
    (state: AppState) => state.eventSystems
)

export const { 
  selectIds: selectEventSystemIds,
  selectEntities: selectEventSystemEntities,
  selectAll: selectAllEventSystems,
  selectTotal: selectTotalEventSystems,
} = systemAdapter.getSelectors(selectEventSystemStore)

export const selectEventSystem = (systemRef: string) => createSelector(
    selectAllEventSystems,
    state => state.find(item => item.systemRef === systemRef)
)